// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
			//suggestionMode: 'test',
			//suggestionPosition: 'left'
	}
};

(function() {
	BoostPFS.inject(this);

    function faLooxGetInstantMetafield(data, key) {
        if (typeof Utils !== 'undefined' && typeof Utils.getProductMetafield === 'function') {
            var value = Utils.getProductMetafield(data, 'loox', key);
            if (value !== null && typeof value !== 'undefined') return value;
        }
        if (data && Array.isArray(data.metafields)) {
            for (var index = 0; index < data.metafields.length; index += 1) {
                if (data.metafields[index].namespace === 'loox' && data.metafields[index].key === key) {
                    return data.metafields[index].value;
                }
            }
        }
        if (data && data.metafields && data.metafields.loox && typeof data.metafields.loox[key] !== 'undefined') {
            return data.metafields.loox[key];
        }
        return '';
    }

    function faLooxEscapeInstantAttribute(value) {
        return String(value == null ? '' : value)
            .replace(/&/g, '&amp;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;');
    }

    function faLooxInstantHasReviews(rating, count) {
        return rating !== '' && count !== '' && isFinite(rating) && isFinite(count) &&
            Number(rating) > 0 && Number(rating) <= 5 && Number(count) > 0 &&
            Math.floor(Number(count)) === Number(count);
    }

    function faLooxGetInstantHandle(data) {
        if (data && data.handle) return String(data.handle);
        var url = data && data.url ? String(data.url) : '';
        var match = url.match(/\/products\/([^?#/]+)/);
        return match ? match[1] : '';
    }

    function faLooxBuildInstantReviews(data) {
        if (!data || !data.id) return '';
        var rating = faLooxGetInstantMetafield(data, 'avg_rating');
        var count = faLooxGetInstantMetafield(data, 'num_reviews');
        if (!faLooxInstantHasReviews(rating, count)) {
            var handle = faLooxGetInstantHandle(data);
            if (!handle) return '';
            return "<span class='fa-loox-rating-shell' data-fa-loox-id='" + faLooxEscapeInstantAttribute(data.id) + "' data-fa-loox-handle='" + faLooxEscapeInstantAttribute(handle) + "'></span>";
        }
        return "<div class='loox-rating' data-id='" + faLooxEscapeInstantAttribute(data.id) + "' data-rating='" + faLooxEscapeInstantAttribute(rating) + "' data-raters='" + faLooxEscapeInstantAttribute(count) + "' data-pattern='([count])'></div>";
    }


    InstantSearchMobile.prototype.afterShowSearchBoxMobile = function(searchBoxId) {
        if (!searchBoxId) searchBoxId = this.searchBoxId;
        // Hide debut's search bar on mobile, and show our search bar instead
        if (jQ('.js-drawer-close').length > 0) {
            setTimeout(function() {
                jQ('.js-drawer-close').trigger('click');
            });
        }
      jQ('.boost-pfs-search-btn-close-suggestion').on('click',function(){
            jQ('#body').removeClass('js-drawer-open js-drawer-open-top')
        })
    };
    
    SearchInput.prototype.customizeInstantSearch = function() {
        // Hide debut's search suggestion
        if (jQ('.predictive-search-wrapper').length > 0) {
            jQ('.predictive-search-wrapper').hide();
        }
    };
    
    function closeSuggestionMobile(searchBoxId, isCloseSearchBox) {
        /* console.log('closeSuggestionMobile'); */
        jQ(searchBoxId).autocomplete('close');
        jQ('.' + Class.searchSuggestion + '[data-search-box="' + searchBoxId + '"]').parent().hide();
        // Remove search box
        var isCloseSearchBox = typeof isCloseSearchBox !== 'undefined' ? isCloseSearchBox : false;
        if (isCloseSearchBox) jQ('.boost-pfs-search-suggestion-mobile-top-panel,.boost-pfs-search-suggestion-mobile-overlay').hide();
        // Update current term for all search boxes
        setValueAllSearchBoxes();
        // Add back tabindex=-1
        jQ('.boost-pfs-search-no-tabindex').attr('tabindex', -1);
        // Return scrolling of body
        if (jQ('body').hasClass(Class.searchSuggestionMobileOpen)) {
            jQ('body').removeClass(Class.searchSuggestionMobileOpen);
        }
        BoostPFS.afterCloseSuggestionMobile(searchBoxId, isCloseSearchBox);
    
        // Close search theme debut
        if (jQ('.js-drawer-close').length > 1) {
            jQ('.js-drawer-close').trigger('click');
        }
    }

    InstantSearchResultItemProduct.prototype.getTemplate = function(tempType) {
		switch (tempType) {
			case InstantSearchResultItemProduct.tempType.IMAGE:
				return `
					<div class="{{class.searchSuggestion}}-left">
						<img tabindex="-1" src="{{imageUrl}}" alt="{{escapedTitle}}">
					</div>
				`.trim();
			case InstantSearchResultItemProduct.tempType.SKU:
				return `
					<p class="{{class.searchSuggestion}}-product-sku">SKU: {{sku}}</p>
				`.trim();
			case InstantSearchResultItemProduct.tempType.VENDOR:
				return `
					<p class="{{class.searchSuggestion}}-product-vendor">{{vendor}}</p>
				`.trim();
			case InstantSearchResultItemProduct.tempType.PRICE:
				return `
					<p class="{{class.searchSuggestion}}-product-price">
						{{fromText}}
						<span class="{{class.searchSuggestion}}-product-regular-price">{{regularPrice}}</span>
					</p>
				`.trim();
			case InstantSearchResultItemProduct.tempType.PRICE_SALE:
				return `
					<p class="{{class.searchSuggestion}}-product-price">
                        {{fromText}}
						<s>{{regularPrice}}</s>&nbsp;
                        <span class="{{class.searchSuggestion}}-product-sale-price">{{salePrice}}</span>
					</p>
				`.trim();
			default:
				return `
					<li class="{{class.searchSuggestionItem}} {{class.searchSuggestionItem}}-product {{class.searchUiAutocompleteItem}}" aria-label="{{escapedBlockType}}: {{escapedTitle}}" data-id="{{id}}" role="option">
						<a tabindex="-1" href="{{url}}" {{newTabAttribute}}>
							{{itemProductImage}}
							<div class="{{class.searchSuggestion}}-right">
								<p class="{{class.searchSuggestion}}-product-title">{{title}}</p>
                                {{itemProductReviews}}
								{{itemProductSku}}
								{{itemProductVendor}}
								{{itemProductPrice}}
								{{itemProductType}}
								{{itemStock}}
							</div>
						</a>
					</li>
				`.trim();
		}
	}
      InstantSearchNoResult.prepareProducts = (products) => {
        if (!Array.isArray(products)) return [];
        products.forEach((product) => {
            // Generate the images_info of product
            var images_info = [];
            if (!Array.isArray(product.media)) product.media = [];
            product.media.forEach((media) => {
                if (media.media_type == 'image') {
                    images_info.push({
                        id: media.id,
                        position: media.position,
                        src: media.src,
                        width: media.width,
                        height: media.height
                    });
                }
            });

            product.images_info = images_info;
            product.price /= 100;
            product.price_min /= 100;
            product.price_max /= 100;
            product.compare_at_price /= 100;
            product.compare_at_price_min /= 100;
            product.compare_at_price_max /= 100;

            if (jQ(Selector.searchNoResultJson).length > 0) {
    			try {
    				var noSearchResultJson = JSON.parse(jQ(Selector.searchNoResultJson).html());
    				if (Array.isArray(noSearchResultJson.products) && noSearchResultJson.products.length > 0) {
    					data = noSearchResultJson.products;
    				}
    				
    				//Get metafields data if available
            		if (jQ('#boost-pfs-instant-search-products-not-found-metafields-json').length > 0) {
    					var noSearchResultMetafieldsJson = JSON.parse(jQ('#boost-pfs-instant-search-products-not-found-metafields-json').html());
    					for (var i = 0; i< noSearchResultMetafieldsJson.products.length; i++) {
                            if (product.id == noSearchResultMetafieldsJson.products[i].id) {
                                product.metafields = noSearchResultMetafieldsJson.products[i].metafields;
                            }
    					}
    				}
    			} catch {
    				// TODO: (...)
    			}
    		}
        });
        return products;
    }

    InstantSearchResultItemProduct.prototype.compileTemplate = function() {
		if (this.isShow) {
			var searchTerm = Utils.stripHtml(Globals.currentTerm);
			// Product image
			var imageHTML = '';
			if (Settings.getSettingValue('search.showSuggestionProductImage') && this.imageUrl.length) {
				imageHTML = this.getTemplate(InstantSearchResultItemProduct.tempType.IMAGE);
				imageHTML = imageHTML.replace(/{{imageUrl}}/g, this.imageUrl);
			}
			// Product title
			var productTitle = this.customizeProductTitle();
			productTitle = this._highlightSuggestionResult(productTitle, searchTerm);
          
            var itemReviewsHtml = faLooxBuildInstantReviews(this.data);
          
			// SKU
			var skuHTML = '';
			if (Settings.getSettingValue('search.showSuggestionProductSku') && this.sku.length) {
				skuHTML = this.getTemplate(InstantSearchResultItemProduct.tempType.SKU);
				skuHTML = skuHTML.replace(/{{sku}}/g, this.sku);
			}
			// Vendor
			var vendorHTML = '';
			if (Settings.getSettingValue('search.showSuggestionProductVendor') && this.vendor.length) {
				vendorHTML = this.getTemplate(InstantSearchResultItemProduct.tempType.VENDOR);
				vendorHTML = vendorHTML.replace(/{{vendor}}/g, this.vendor);
			}
			// Price
			var priceHTML = this.compileSuggestionProductPrice();
			// Open the result item in new tab when selected
			var newTabAttr = Settings.getSettingValue('search.openProductNewTab') ? 'target="_blank"' : '';

			let productType = this.data.product_type ?? this.data.type;
            var productTypeHtml = '<div class="{{class.searchSuggestion}}-product-type">' + productType + '</div>';

            // Get stock (by Michael)
            var itemStockHtml = this.compileSuggestionProductStockLabel();
			return this.getTemplate()
				.replace(/{{id}}/g, this.id)
				.replace(/{{escapedBlockType}}/g, Utils.stripHtml(this.parent.type))
				.replace(/{{url}}/g, this.url)
				.replace(/{{newTabAttribute}}/g, newTabAttr)
				.replace(/{{itemProductImage}}/g, imageHTML)
				.replace(/{{title}}/g, productTitle)
				.replace(/{{escapedTitle}}/g, Utils.stripHtml(productTitle))
				.replace(/{{itemProductSku}}/g, skuHTML)
				.replace(/{{itemProductVendor}}/g, vendorHTML)
				.replace(/{{itemProductType}}/g, productTypeHtml)
				.replace(/{{itemStock}}/g, itemStockHtml)
				.replace(/{{itemProductPrice}}/, priceHTML)
				.replace(/{{class.searchSuggestion}}/g, Class.searchSuggestion)
				.replace(/{{class.searchSuggestionItem}}/g, Class.searchSuggestionItem)
				.replace(/{{class.searchUiAutocompleteItem}}/g, Class.searchUiAutocompleteItem)
                .replace(/{{itemProductReviews}}/g, itemReviewsHtml);
		} else {
			return '';
		}
	}

	// -Start- FiguredArt integration
  	/*
		Added by hwei@figuredart.com on Dec. 24th, 2022 based on the discussion with Anthony
		For more information, please read the comments in the `snippets/product-price.liquid`
	*/
	function getFirstVariant(product) {
		for (const theVariant of product.variants) {
			return theVariant;
		}
		return null;
	}

	function getFirstAvailableVariant(product) {
		for (const theVariant of product.variants) {
			if (theVariant.available) {
				return theVariant;
			}
		}
		return null;
	}
	
	function getCheapestDiscountVariant(product) {
		let cheapestDiscountVariant = null;
		for (const theVariant of product.variants) {
			if (theVariant.available) {
				let compareAtPrice = parseFloat(theVariant.compare_at_price);
				let price = parseFloat(theVariant.price);
				if (theVariant.compare_at_price !== null && compareAtPrice > price) {
					if (
						cheapestDiscountVariant === null ||
						parseFloat(cheapestDiscountVariant.price) > price
					) {
						cheapestDiscountVariant = theVariant;
					}
				}
			}
		}
		return cheapestDiscountVariant;
	}

	function parsePrice(price_raw, price_max) {
		let price = parseFloat(price_raw);
		// Due to unknown issue, 3 types of price may return
		// 1. 3914: an integer (liquid object uses this type)
		// 2. "39.14": a string of floating number (Boost API may transform an integer to this form)
		// 3. 39.14: a floating number (Boost API may return this and product level always uses this form, e.g., this.data.price_max)
		if (price > price_max) {
			// If price is 3914 type, we need formulate it to a normal price
			return price / 100;
		}
		return price;
	}

    InstantSearchResultItemProduct.prototype.compileSuggestionProductPrice = function() {
		// If the multi-currency feature is enabled, update the product price
		this.prepareSuggestionProductPriceData();

        var priceVaries = this.data.price_min != this.data.price_max;

		// * Start to build the cheapest discount variant price *
		//
		// Added by hwei@figuredart.com on Dec. 24th, 2022
		// For more information, please read the comments in the `snippets/product-price.liquid`

		// Try to get the cheapest discount variant
		let selectedVariant = getCheapestDiscountVariant(this.data);		
		if (selectedVariant == null) {
			// If we can't find one, then try to find the first available variant
			selectedVariant = getFirstAvailableVariant(this.data);
			if (selectedVariant == null) {
				// If no available variant in the product, we fallback to select the first variant
				// The following code will render it as sold_out
				selectedVariant = getFirstVariant(this.data);
			}
		}

		// product must have at least variant, so selectedVariant must be non null.
		// compare_at_price is the original price; price is the actual price
		let price = parsePrice(selectedVariant.price, this.data.price_max);
		// Utils.formatMoney requires number as argument, we must convert price to float (it is string by default)
		let formattedPrice = Utils.formatMoney(price, Globals.moneyFormat);
		if (Settings.getSettingValue("search.removePriceDecimal")) {
			formattedPrice = Utils.removeDecimal(formattedPrice);
		}

		let compareAtPrice = price;
		let formattedCompareAtPrice = "";
		let onSale = false;
		if (selectedVariant.compare_at_price !== null) {
			compareAtPrice = parseFloat(selectedVariant.compare_at_price);
			// Utils.formatMoney requires number as argument, we must convert price to float (it is string by default)
			formattedCompareAtPrice = Utils.formatMoney(compareAtPrice, Globals.moneyFormat);
			if (Settings.getSettingValue("search.removePriceDecimal")) {
				formattedCompareAtPrice = Utils.removeDecimal(formattedCompareAtPrice);
			}
			onSale = compareAtPrice > price;
		}
		// * End to build the cheapest discount variant price  *
      
		// Build Price
		var result = '';
		if (Settings.getSettingValue('search.showSuggestionProductPrice')) {
			if (this.data.available) {
				let fromText = priceVaries ? (boostPFSConfig.label.from + '&nbsp;') : '';
				if (onSale && Settings.getSettingValue('search.showSuggestionProductSalePrice')) {
					result += this.getTemplate(InstantSearchResultItemProduct.tempType.PRICE_SALE)
						.replace(/{{fromText}}/g, fromText)
						.replace(/{{regularPrice}}/g, formattedCompareAtPrice)
						.replace(/{{salePrice}}/g, formattedPrice);
				} else {
					result += this.getTemplate(InstantSearchResultItemProduct.tempType.PRICE)
						.replace(/{{fromText}}/g, fromText)
						.replace(/{{regularPrice}}/g, formattedPrice);
				}
			} else {
				result += this.getTemplate(InstantSearchResultItemProduct.tempType.PRICE)
					.replace(/{{fromText}}/g, '')
					.replace(/{{regularPrice}}/g, boostPFSConfig.label.sold_out);
			}
		}
		return result;
	}

	InstantSearchResultItemProduct.prototype.compileSuggestionProductStockLabel = function() {
		let itemStockHtml = '<div class="items-left"><span class="badge badge-success"><i class="fas fa-check-circle" aria-hidden="true"></i>&nbsp;' + 
			boostPFSConfig.label.instock + 
			'</span></div>';
		// Update the rule by hwei@figuredart.com after discussing it with Anthony on Jan. 3rd, 2023

		// There is a special logic for ES:
		//
		// We have a warehouse in Spain. It is small, we don't have too much stock but that allows us to deliver in 48h in all Spain.
		// As it is small and we want to look attractive, we have set up our order management system to be like this:
		// - If the order contains "bigblue (local stock) products which are available in Spain, we ship from Spain
		// - If the order contains "bigblue (local stock) products which are not all available in Spain but are available in France, we ship from France
		// So Spain is the only website for which NOT having local stock doesn't necessarily means not having the green label
		//
		// So basically for Spain only the rule is:
		// > if any variant inventory is > 0, then "stock" label should appear
		// > OR product tag = stock THEN green label
		for (const theVariant of this.data.variants) {
			if (theVariant.inventory_quantity > 0) {
				return itemStockHtml;
			}
		}

		if (this.data.tags.includes("stock")) {
			return itemStockHtml;
		}

		return ''

		// The old logic added (by Michael)	
		// let hasStock = (this.data.variants[0].inventory_quantity > 0 || 
		// 	(this.data.variants.length > 1 && this.data.variants[1].inventory_quantity > 0) || 
		// 	(this.data.variants.length > 2 && this.data.variants[2].inventory_quantity > 0) || 
		// 	(this.data.variants.length > 4 && this.data.variants[4].inventory_quantity > 0));
		// return hasStock ? itemStockHtml : '';
	}
	// -End- FiguredArt integration

    // Start Boost 159138
    var originalBindEvents = SearchInput.prototype.bindEvents;
    SearchInput.prototype.bindEvents = function() {
        var _this = this;
        originalBindEvents.call(_this);
        if (!Utils.isMobile() && jQ(".template-search .input-group__btn .search__submit").length > 0) {
            jQ(".template-search .input-group__btn .search__submit").on("click", function() {
                _this.$searchForm.on('submit', _this._onSubmit.bind(_this));
            });
        }
    };
  
    var isDisabledInstantSearch = false;
    SearchInput.prototype._onSubmit = function(event, redirect) {
        if (isDisabledInstantSearch) return;
    
        if (typeof redirect == 'undefined') {
            redirect = this.isChangePage;
        }
        this.isChangePage = false;
    
        if (!redirect) {
            // Stop all default submit events
            event.stopImmediatePropagation();
            event.stopPropagation();
            event.preventDefault();
            // Fix case can not get current value from input
            Globals.currentTerm = Utils.stripHtml(this.$element.val());
            if (!Globals.currentTerm && event && event.target) {
                Globals.searchTerm = Utils.stripHtml(event.target.value);
            }
            var redirectUrl = InstantSearchResultRedirect.getSearchRedirectUrl();
    
            // if API returned results or the suggestionCache has the search term, submit search
            // else: add the data-search-submit attribute to the search input box, wait for the api returns the result,
            // then remove this attribute in the checkForSearchRedirect function
            var query = Utils.unescape(Globals.currentTerm);
            query = query.trim().replace(/\s+/g, ' ');
            var isApiReturnedResult = Globals.suggestionCache.hasOwnProperty(query);
            // Set recent searches
            InstantSearchOnclick.setOnClickRecentSearches(query);
            // If the API returned results, either redirect or perform submit
            if (isApiReturnedResult) {
                console.log('check 23')
                if (redirectUrl && !Utils.isBadUrl(redirectUrl)) {
                    Utils.setWindowLocation(redirectUrl);
                } else {
                    this.isChangePage = true;
                    this.$searchForm[0].submit();
                }
            } else if (Globals.currentTerm) {
                // If the API hasn't returned results, set data-search-submit on the search input and wait
                this.$element.data('search-submit', true);
            } else {
                this.isChangePage = true;
                this.$searchForm[0].submit();
            }
        }
    }
    // End Boost 159138
})();
